module.exports = __webpack_public_path__ + "img/Tk.cb254ee4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Tk.svg
// module id = ECLB
// module chunks = 1